import { BankInfo, CheckoutDetail } from 'app/pages/Checkout/slice/types';
import checkPrintTickets from 'app/pages/NewPaymentCallback/utils/checkPrintTickets';
import { BaseXHR } from 'utils/axios';
import { addTicketType } from 'utils/helper';

export const checkoutAddressApi = (form: FormData) =>
  BaseXHR.$post(`checkout/address`, form);

export const checkoutCommitApi = (form?: FormData) =>
  BaseXHR.$post(`checkout/commit`, form);

export const getDetailOrderApi = (
  id: string,
  isLogged?: boolean,
  idItem?: string,
  otp?: string,
) => {
  const suffix = idItem ? `?idItem=${idItem}` : '';
  const { accessPrintTicketFromEmailLink } = checkPrintTickets();
  const params = accessPrintTicketFromEmailLink
    ? { guest: 1, otp: !!otp ? otp : undefined }
    : {};
  return BaseXHR.$get(`b2b/v1/order/detail/${id}` + suffix, params);
};

export const getOrderDetailApi = ({
  id,
  idItem,
  otp,
}: {
  id: string;
  idItem?: string;
  otp?: string;
}) => {
  const suffix = idItem ? `?idItem=${idItem}` : '';
  const { accessPrintTicketFromEmailLink } = checkPrintTickets();
  const params = accessPrintTicketFromEmailLink
    ? { guest: 1, otp: !!otp ? otp : undefined }
    : {};
  return BaseXHR.$get(`b2b/v1/order/detail/${id}` + suffix, params);
};

export const downloadPdfApi = (
  id: string,
  isLoading: (load: boolean) => void,
  name?: string,
  otp?: string,
  guest?: string,
) => {
  isLoading && isLoading(true);
  BaseXHR.$get(`b2b/v1/order/download-pdf/${id}`, {
    otp: !!otp ? otp : undefined,
    guest: !!guest ? guest : undefined,
  }).then((res: any) => {
    const blob = new Blob([res.data], {
      type: 'application/pdf',
    });
    try {
      if (name) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        window.location.href = URL.createObjectURL(blob);
      }
    } catch (error) {
    } finally {
      isLoading && isLoading(false);
    }
  });
};

export const downloadListPdfApi = (
  param:
    | string
    | string[][]
    | Record<string, string>
    | URLSearchParams
    | undefined
    | any,
  isLoading?: (load: boolean) => void,
) => {
  isLoading && isLoading(true);
  const searchParams = new URLSearchParams({
    url: param?.url,
    otp: !!param?.otp ? param?.otp : undefined,
    guest: !!param?.guest ? param?.guest : undefined,
  });
  BaseXHR.$get(
    `b2b/v1/order/download-pdf-cms/` + param.id + '?' + searchParams,
  ).then((res: any) => {
    try {
      const blob = new Blob([res.data], {
        type: 'application/pdf',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = param?.name;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
    } finally {
      isLoading && isLoading(false);
    }
  });
};

export const downloadAndViewPdf = (
  id: string,
  setIsLoading: (load: boolean) => void,
  otp?: string,
  guest?: string,
) => {
  setIsLoading && setIsLoading(true);
  BaseXHR.$get(`b2b/v1/order/download-pdf/${id}`, {
    otp: !!otp ? otp : undefined,
    guest: !!guest ? guest : undefined,
  }).then((res: any) => {
    const blob = new Blob([res.data], { type: 'application/pdf' });
    try {
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (error) {
    } finally {
      setIsLoading && setIsLoading(false);
    }
  });
};

export const downloadTicketPdfApi = (
  param:
    | string
    | string[][]
    | Record<string, string>
    | URLSearchParams
    | undefined,
  isLoading?: (load: boolean) => void,
  name?: string,
) => {
  isLoading && isLoading(true);
  const searchParams = new URLSearchParams(param);
  BaseXHR.$get(`b2b/v1/order/download-ticket-pdf?` + searchParams)
    .then((res: any) => {
      try {
        const blob = new Blob([res.data], {
          type: 'application/pdf',
        });
        if (name) {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = name;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        } else {
          window.location.href = URL.createObjectURL(blob);
        }
      } catch (error) {
      } finally {
        isLoading && isLoading(false);
      }
    })
    .catch(() => {
      isLoading && isLoading(false);
    });
};

export const downloadSelectedPdfApi = data =>
  BaseXHR.$post('b2b/v1/order/download-multiple-ticket-pdf', data);

export const createNewOrderApi = (form: FormData) =>
  BaseXHR.$post(`b2b/v1/checkout/quick-create-order`, addTicketType(form));

export const getPaymentMethodApi = (payload: any) =>
  BaseXHR.$get(`b2b/v1/payment/method-listing`, payload);

export const updatePaymentApi = (params: string) =>
  BaseXHR.$get(`payment/vnp-callback${params}`);

export const getCheckoutDetailOrderApi = (id: string) =>
  BaseXHR.$get<CheckoutDetail>(`b2b/v1/order/detail/${id}`);

export const getAccountPaymentGuide = () =>
  BaseXHR.$get<BankInfo>(`b2b/v1/business-partner/banking-info`);

export const createCheckoutPaymentApi = (form: FormData) =>
  BaseXHR.$post(`b2b/v1/checkout/payment`, form);

export const updateCheckoutPaymentApi = (form: FormData) =>
  BaseXHR.$post(`b2b/v1/order/update`, form);

export const getListTicketFormApi = () =>
  BaseXHR.$get(`b2b/v1/payment/method-listing`);

export const pendingCountdownOrderApi = (form: FormData) => {
  return BaseXHR.$post(`b2b/v1/order/pending-countdown`, form);
};
